module.exports = __webpack_public_path__ + "96370982141b815ab59204d370a9c762.MP3";